import { getAntiforgeryToken } from "./antiforgery";

const SAFE_METHODS = new Set(["GET", "HEAD", "OPTIONS", "TRACE"]);

const isSafeMethod = (method?: string) => SAFE_METHODS.has((method ?? "GET").toUpperCase());

const shouldSkipAntiforgery = (input: RequestInfo) => {
  const url = typeof input === "string" ? input : input instanceof Request ? input.url : "";
  return url.includes("/api/security/antiforgery-token");
};

export const createApiFetch = (timeoutMs: number) => {
  return async (input: RequestInfo, init?: RequestInit) => {
    const controller = new AbortController();
    const timeoutId = window.setTimeout(() => controller.abort(), timeoutMs);

    try {
      const method = (init?.method ?? (input instanceof Request ? input.method : "GET")).toUpperCase();
      const headers = new Headers(init?.headers ?? (input instanceof Request ? input.headers : undefined));

      if (!isSafeMethod(method) && !headers.has("X-XSRF-TOKEN") && !shouldSkipAntiforgery(input)) {
        const token = await getAntiforgeryToken(timeoutMs);
        headers.set("X-XSRF-TOKEN", token);
      }

      const response = await fetch(input, {
        ...init,
        headers,
        credentials: init?.credentials ?? "include",
        signal: controller.signal,
      });

      if (response.status === 401) {
        window.dispatchEvent(new CustomEvent("moneylights:auth-expired"));
      }

      return response;
    } finally {
      window.clearTimeout(timeoutId);
    }
  };
};
